import { Component, OnInit, ViewEncapsulation, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import * as d3 from "d3";
import { CloStateService } from "../../../core-module/services/state/clo-state.service";
import { GraphStateService } from "../../../core-module/services/state/graph-state.service";
import { CloGraphBase } from "../clo-graph-base";

@Component({
  standalone: false,
  selector: 'app-clo-lite-graph',
  templateUrl: './clo-lite-graph.component.html',
  styleUrls: ['./clo-lite-graph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CloLiteGraphComponent extends CloGraphBase implements OnInit, OnDestroy {
  enableGraphSub;
  graphDataSub;

  protected get graphState(): GraphStateService {
    return this._graphState;
  }

  constructor(
    private readonly _graphState: GraphStateService,
    private clo: CloStateService
  ) {
    super();
  }

  ngOnInit() {
    this.enableGraphSub = this._graphState.checkCloLiteEnableGraph.subscribe((data) => {
      if (data != null) {
        if (data === true) {
          this.graphDisabled = true;
        } else if (data === false) {
          this.graphDisabled = false;
        }
      }
    });

    this.graphDataSub = this._graphState.getGraphData.subscribe((data) => {
      if (data != "") {
        if (data.graphPoints.length) {
          this.data = data.graphPoints;
          this.graphType = data.graphType;
          this.expandNonInterpolationData();

          const newdataLeangth = this.data.length;
          if (this.data[newdataLeangth - 1].hour < 120) {
            this.data[newdataLeangth] = {
              hour: 120,
              power: this.data[newdataLeangth - 1].power,
            };
          }
          this.subscription = this.clo.getCloLiteHead.subscribe(
            (data) => {
              if (
                this.data.length > 0 &&
                (data === "CloLite" || data === "Clolite")
              ) {
                const hour = this.data[1].hour;
                const power = this.data[0].power;
                this.clo.sendliteHour(hour);
                this.clo.sendLitePower(power);
              }
            }
          );
          this.buildSvg();
          this.addXandYAxis();
          this.drawLineAndPath();
          this.addDrag();
        }
        if (!data["graphPoints"].length) {
          d3.selectAll("#svg2 > *").remove();
        }
      }
    });
  }

  public drawLineAndPath() {
    this.applyRenderedGraph(this.data, 0 - this.height / 1.4 + 35);
  }

  public dragended(d) {
    if (!this.successfullDrag) {
      return;
    }

    const newArrayData = this.collapseAndValidate(true);
    this._graphState.sendGraphValues(newArrayData);
    this._graphState.updateGraphData(newArrayData);
  }

  checkValidInputRange(inputData) {
    this.collapseAndValidate(true);
  }

  ngOnDestroy() {
    this._graphState.updateGraphData([]);
    this._graphState.sendGraphValues("");
    this.data = [];
    if (this.enableGraphSub) {
      this.enableGraphSub.unsubscribe();
    }
    if (this.graphDataSub) {
      this.graphDataSub.unsubscribe();
    }
  }
}
